<div class="eb-cards row mx-0 pl-0 pr-0 helpMenu" role="dialog" aria-modal="true" aria-labelledby="helpModalTitle">
  <div class="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12 pl-0 pr-0">
    <div class="border-0">
      <div class="mx-0 p-3 pb-lg-3 row help-menu-header bg-header-color">
        <div class="col-9 col-xl-9 pl-0">
          <h5 class="modal-title pb-2 pt-2" id="helpModalTitle">
            <img src="assets/images/help.svg" alt="" />&nbsp;<span class="font-weight-600 font-24 ml-2">
              Help Center</span
            >
          </h5>
        </div>
        <div class="col-xl-3 col-3 text-right pr-lg-0 pr-0">
          <button
            type="button"
            class="bg-transparent border-0"
            aria-label="Close"
            tabindex="3"
            (keyup.enter)="modalRef.close('')"
            (click)="modalRef.close('')">
            <img src="assets/images/close.png" class="close-focus" alt="" />
          </button>
        </div>
      </div>
      <div class="mt-2 pb-0">
        <ul class="pl-0 menu-list">
          <li
            class="menu-items guide-menu-item px-4 mx-0 mt-lg-4 mt-2 cursor-pointer"
            role="button"
            aria-label="Open guides and frequently asked questions"
            tabindex="3"
            (keyup.enter)="redirectToFaqs()"
            (click)="redirectToFaqs()">
            <img src="assets/images/menu_book.png" alt="icon" /><span
              class="font-ubuntu font-weight-bold ml-2 ml-lg-3 font-16-lg"
              >Guides and FAQ’s
              <p class="pl-5 font-weight-400 font-16-lg">View instructional guides and FAQ’s.</p></span
            >
          </li>
          <li
            class="menu-items px-4 mx-0 mt-lg-4 mt-2 cursor-pointer d-flex align-items-center"
            role="button"
            aria-label="Open support tickets"
            tabindex="3"
            (keyup.enter)="redirectToSupportTickets()"
            (click)="redirectToSupportTickets()"
            *ngIf="showSupportTickets">
            <img src="assets/images/supportHelpIcon.svg" alt="icon" />&nbsp;<span
              class="font-ubuntu font-weight-bold ml-lg-3 ml-2 d-inline-block font-16-lg"
              >Support Tickets
              <p class="pl-5 font-weight-400 font-16-lg">View and submit customer support ticket</p></span
            >
          </li>
          <li class="menu-items px-4 mx-0 mt-lg-3 mt-2" style="display: none">
            <img src="assets/images/feedback.png" alt="icon" /><span class="ml-lg-3 ml-2">Report an Issue</span>
          </li>
          <li class="menu-items px-4 mx-0 mt-lg-3 mt-2" style="display: none">
            <a class="text-decoration-underline text-blue">COVID Policies</a>
          </li>
        </ul>
        <div class="font-16 menu-items pb-lg-3 pt-lg-2 road-assistance pt-2 pb-2 mt-4">
          <div class="font-weight-bold">
            <i class="fcr fcr-roadside mr-1 font-weight-bold font-16-lg"></i>Need assistance now?
          </div>
          <div class="d-inline-flex" *ngIf="brandingInfo?.supportPhone">
            <div class="call-number mt-lg-2 pl-1">
              <i class="fc fc-phone mr-2 text-muted"></i
              ><span class="font-16-lg">{{ brandingInfo?.supportPhone }}</span>
            </div>
            <div class="call-number mt-lg-2 pl-lg-4 pl-4">
              <span class="font-16-lg">{{ brandingTime }}</span>
            </div>
          </div>

          <div class="call-number mt-lg-2 pl-1">
            <i class="fc fc-message mr-2 text-muted"></i
            ><span class="text-decoration-underline font-16-lg word-wrap"
              ><a href="mailto:customerservice@edenred.com">{{ brandingInfo?.supportEmail }}</a></span
            >
          </div>
        </div>
        <div
          class="font-16 menu-items pb-lg-3 pt-lg-2 road-assistance pt-2 pb-2"
          *ngIf="company?.tpaCompanyId === 'B2346'">
          Select 'Well Being and Other Programs' from the Main Menu and then 'Commuter Services' to be connected with a
          representative that can assist.
        </div>
      </div>
    </div>
  </div>
</div>
